/** Roles for sandbox collaborators (does NOT include 'owner'). */
export type CollaboratorRole = 'editor' | 'viewer';

/** All possible roles including the implicit owner role. */
export type SandboxRole = 'owner' | CollaboratorRole;

/** Valid characters for sandbox session names. */
export const SANDBOX_NAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9._-]{0,63}$/;

/** Validate a sandbox session name. */
export function isValidSandboxName(name: string): boolean {
  return SANDBOX_NAME_PATTERN.test(name);
}
